import { Compass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, Card, EmptyState } from "@/components/ui";

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card flush>
      <EmptyState
        icon={Compass}
        title={t("notFound.title")}
        description={t("notFound.description")}
        action={
          <Button variant="primary" onClick={() => navigate("/dashboard")}>
            {t("notFound.action")}
          </Button>
        }
      />
    </Card>
  );
}
